import { Pen, Trash } from "lucide-react";
import { useEffect } from "react";

export default function DriverConfigTable({
  rows,
  onEdit, // (driverCode) => void
  onDelete, // (configId) => void
  deletingId,
}) {

  return (
    <div className="overflow-x-auto border rounded-md shadow-sm">
      <table className="min-w-full bg-white">
        <thead>
          <tr className="bg-orange-400 text-left text-sm font-semibold text-white">
            <th className="px-4 py-2 text-center">Config ID</th>
            <th className="px-4 py-2 text-center">Driver Code</th>
            <th className="px-4 py-2 text-center">Driver Name</th>
            <th className="px-4 py-2 text-center">Team</th>
            <th className="px-4 py-2 text-center">Team ID</th>
            <th className="px-4 py-2 text-center">Driver Type</th>
            <th className="px-4 py-2 text-center">Tier</th>
            <th className="px-4 py-2 text-center">KYC</th>
            <th className="px-4 py-2 text-center">On Duty</th>
            <th className="px-4 py-2 text-center">Cash Limit</th>
            <th className="px-4 py-2 text-center">Daily Task</th>
            <th className="px-4 py-2 text-center">Concurrent</th>
            <th className="px-4 py-2 text-center">Max Team</th>
            <th className="px-4 py-2 text-center">Per Day</th>
            <th className="px-4 py-2 text-center">Per Order</th>
            <th className="px-4 py-2 text-center">Created</th>
            <th className="px-4 py-2 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {(rows || []).map((r) => (
            <tr key={r.pk_config_id} className="text-sm border-t">
              <td className="px-4 py-2 text-center">{r.pk_config_id}</td>
              <td className="px-4 py-2 text-center">{r.driver_code}</td>
              <td className="px-4 py-2 text-center">{r.name}</td>

              <td className="px-4 py-2 text-center">{r.team_name || "-"}</td>
              <td className="px-4 py-2 text-center">{r.team_id || "-"}</td>
<td className="px-4 py-2 text-center">
  <span
    className={`px-2 py-1 rounded-full text-xs font-semibold ${
      r.driver_type === "full_time"
        ? "bg-blue-100 text-blue-700"
        : r.driver_type === "part_time"
        ? "bg-purple-100 text-purple-700"
        : "bg-gray-100 text-gray-700"
    }`}
  >
    {r.driver_type
      ? r.driver_type.replace("_", " ")
      : "-"}
  </span>
</td>
              <td className="px-4 py-2 text-center">{r.tier_level || "-"}</td>

           <td className="px-4 py-2 text-center">
  <span
    className={`px-2 py-1 rounded-full text-xs font-semibold ${
      r.kyc_status === "A"
        ? "bg-green-100 text-green-700"
        : r.kyc_status === "R"
        ? "bg-red-100 text-red-700"
        : "bg-yellow-100 text-yellow-700"
    }`}
  >
    {r.kyc_status === "A"
      ? "Approved"
      : r.kyc_status === "R"
      ? "Rejected"
      : "Pending"}
  </span>
</td>

   <td className="px-4 py-2 text-center">
  <span
    className={`px-3 py-1 rounded-full text-xs font-semibold ${
      r.on_duty === 1
        ? "bg-green-100 text-green-700"
        : "bg-red-100 text-red-700"
    }`}
  >
    {r.on_duty === 1 ? "Yes" : "No"}
  </span>
</td>

              <td className="px-4 py-2 text-center">{r.cash_limit}</td>
              <td className="px-4 py-2 text-center">{r.daily_task_limit}</td>
              <td className="px-4 py-2 text-center">{r.concurrent_order}</td>
              <td className="px-4 py-2 text-center">{r.max_team_limit}</td>

              <td className="px-4 py-2 text-center">
                {r.per_day_amount ?? "-"}
              </td>
              <td className="px-4 py-2 text-center">
                {r.per_order_amount ?? "-"}
              </td>

              <td className="px-4 py-2 text-center">
                {r.created_on ? new Date(r.created_on).toLocaleString() : "-"}
              </td>

              <td className="px-4 py-2">
                <div className="flex gap-2 justify-center items-center">
                  <button
                    className="text-blue-600 hover:text-blue-800"
                    onClick={() => onEdit?.(r.driver_code)}
                  >
                    <Pen size={14} />
                  </button>

                  <button
                    className="text-red-600 hover:text-red-800 disabled:opacity-50"
                    onClick={() => onDelete?.(r.pk_config_id)}
                    disabled={deletingId === String(r.pk_config_id)}
                  >
                    <Trash size={14} />
                  </button>
                </div>
              </td>
            </tr>
          ))}
          {!rows?.length && (
            <tr>
              <td
                className="px-4 py-6 text-center text-sm text-gray-500"
                colSpan={11}
              >
                No configurations found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
